import baseUrl from "../userRolesApiHost";
import { callApi } from "./util";

const getUserRoles = () => {
  const url = `${baseUrl}me`;

  return callApi(url);
};

export default {
  getUserRoles
};
